import { useCallback } from "react";
import { trpc } from "../../../lib/api/trpc";

/**
 * Hook for deleting a document
 */
export const useDeleteDocument = () => {
  // Get the trpc context for revalidating queries
  // @ts-ignore - Type checking for trpc.useContext
  const utils = trpc.useContext();

  // Delete document mutation
  // @ts-ignore - Type checking for trpc.documents property
  const { mutateAsync, isLoading, isError, error, isSuccess, reset } =
    trpc.documents.delete.useMutation({
      onSuccess: () => {
        // Invalidate the documents list query to refresh data
        // @ts-ignore - Type checking for utils.documents property
        utils.documents.list.invalidate();
        // Also invalidate quota since document count changed
        // @ts-ignore - Type checking for utils.documents property
        utils.documents.getQuota.invalidate();
      },
    });

  // Function to delete a document with better error handling
  const deleteDocument = useCallback(
    async (documentId: string) => {
      try {
        await mutateAsync({ id: documentId });
        return { success: true };
      } catch (err: any) {
        return {
          success: false,
          error: err?.message || "Failed to delete document",
        };
      }
    },
    [mutateAsync],
  );

  return {
    deleteDocument,
    isLoading,
    isError,
    error,
    isSuccess,
    reset,
  };
};
